import {z} from 'zod'

export const UserListItemSchema = z
    .object({
        id: z.string(),
        email: z.string(),
        name: z.string(),
        is_admin: z.boolean(),
        organization_id: z.nullable(z.string()),
        deactivated_at: z.nullable(z.string()),
    })
    .transform(({is_admin, organization_id, deactivated_at, ...rest}) => ({
        ...rest,
        isAdmin: is_admin,
        organizationId: organization_id,
        deactivatedAt: deactivated_at,
    }))

export const UserListItemResponseSchema = z.array(UserListItemSchema)
export type UserListItem = z.infer<typeof UserListItemSchema>
export type UserListItemResponseInput = z.input<typeof UserListItemSchema>
export type UserListItemResponse = z.infer<typeof UserListItemResponseSchema>

export const UserDetailSchema = z
    .object({
        id: z.string(),
        email: z.string(),
        name: z.string(),
        is_admin: z.boolean(),
        organization_id: z.nullable(z.string()),
        organization_name: z.nullable(z.string()),
        deactivated_at: z.nullable(z.string()),
        last_active_at: z.nullable(z.string()),
    })
    .transform(
        ({
            is_admin,
            organization_id,
            organization_name,
            deactivated_at,
            last_active_at,
            ...rest
        }) => ({
            ...rest,
            isAdmin: is_admin,
            organizationId: organization_id,
            organizationName: organization_name,
            deactivatedAt: deactivated_at,
            lastActiveAt: last_active_at,
        }),
    )
export type UserDetail = z.infer<typeof UserDetailSchema>
export type UserDetailResponseInput = z.input<typeof UserDetailSchema>
